// API Configuration for Admin Panel

const DEFAULT_API_BASE = import.meta.env.DEV
  ? "http://localhost:3000/api/v1"
  : "https://api.ammayumkunjum.com/api/v1";

export const API_BASE_URL = (
  import.meta.env.VITE_API_BASE_URL ||
  import.meta.env.VITE_API_URL ||
  DEFAULT_API_BASE
).replace(/\/$/, "");

// API timeout configuration (in milliseconds)
export const API_TIMEOUT = 30000; // 30 seconds

// API endpoints for admin operations
export const API_ENDPOINTS = {
  // User management
  USERS: {
    LIST: "/admin/users",
    GET: (id: string) => `/admin/users/${id}`,
    UPDATE: (id: string) => `/admin/users/${id}`,
    DELETE: (id: string) => `/admin/users/${id}`,
  },

  // Business management
  BUSINESS: {
    LIST: "/admin/centres",
    GET: (id: string) => `/centres/${id}`,
    UPDATE: (id: string) => `/centres/${id}`,
    DELETE: (id: string) => `/centres/${id}`,
    VERIFY: (id: string) => `/centres/${id}/verify`,
    REJECT: (id: string) => `/centres/${id}/verify`,
  },

  // Services management
  SERVICES: {
    LIST: "/admin/services",
    GET: (id: string) => `/admin/services/${id}`,
    UPDATE: (id: string) => `/admin/services/${id}`,
    DELETE: (id: string) => `/admin/services/${id}`,
  },

  // Booking management
  BOOKINGS: {
    LIST: "/admin/booking",
    GET: (id: string) => `/admin/booking/${id}`,
    UPDATE: (id: string) => `/admin/booking/${id}`,
    DELETE: (id: string) => `/admin/booking/${id}`,
  },

  // Review management
  REVIEWS: {
    LIST: "/admin/reviews",
    GET: (id: string) => `/admin/reviews/${id}`,
    APPROVE: (id: string) => `/admin/reviews/${id}/approve`,
    REJECT: (id: string) => `/admin/reviews/${id}/reject`,
    DELETE: (id: string) => `/admin/reviews/${id}`,
  },

  // Medical professionals management
  MEDICAL_PROFESSIONALS: {
    LIST: "/admin/medical-professionals",
    GET: (id: string) => `/admin/medical-professionals/${id}`,
    VERIFY: (id: string) => `/admin/medical-professionals/${id}/verify`,
    REJECT: (id: string) => `/admin/medical-professionals/${id}/reject`,
  },

  // Advertisement subscriptions
  ADVERTISEMENTS: {
    LIST: "/admin/advertisements",
    GET: (id: string) => `/admin/advertisements/${id}`,
    UPDATE: (id: string) => `/admin/advertisements/${id}`,
    DELETE: (id: string) => `/admin/advertisements/${id}`,
  },

  // Analytics and reports
  ANALYTICS: {
    DASHBOARD: "/admin/analytics/dashboard",
    BOOKINGS: "/admin/analytics/bookings",
    REVENUE: "/admin/analytics/revenue",
    USERS: "/admin/analytics/users",
  },

  // Dashboard statistics
  DASHBOARD: {
    STATS: "/dashboard/stats",
  },
};
